import { useMutation } from 'react-query';
import { publicFetch } from 'utilities/fetch';

function useForgotPassword() {
  async function forgot_password(data) {
    return publicFetch.post(`/v1/resetpassword`, data).then((res) => res.data);
  }

  /*async function otp_Check(data) {
      return publicFetch.post(`/v1/admin/login`, data).then((res) => res.data);
    }

    function manage_Lost_key(data) {
      if (data.type === 'otp') return otp_Check(data);

      return forgot_password(data);
    }*/

  return useMutation(forgot_password, {
    onSuccess() {},
    onError() {},
  });
}

export default useForgotPassword;
